import { render, staticRenderFns } from "./ordinary.vue?vue&type=template&id=023924df&scoped=true&"
import script from "./ordinary.vue?vue&type=script&lang=js&"
export * from "./ordinary.vue?vue&type=script&lang=js&"
import style0 from "./ordinary.vue?vue&type=style&index=0&id=023924df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023924df",
  null
  
)

export default component.exports